import { BaseService } from "../BaseService";
import { SignatureResponse } from "@/dtos/signature/SignatureResponse";
import { SignaturePdfResponse } from "@/dtos/signature/SignaturePdfResponse";
import { GetSignatureByDocumentResponse } from "@/dtos/signature/GetSignatureByDocumentResponse";

class SignatureService extends BaseService {
  async getDocData(hash: string) {
    let route = `/api/signature-process/`;

    if (hash) {
      route += hash;
    }

    route += "/get-documents";

    const response = await this.instance.get<SignatureResponse>(route, this.getConfigHeaders());
    return response.data;
  }

  async getDocPdf(hash: string, id: number) {
    let route = `/api/signature-process/`;

    if (hash) {
      route += hash;
    }

    route += "/pdf/";
    route += id;

    const response = await this.instance.get<SignaturePdfResponse>(route, this.getConfigHeaders());
    return response?.data?.file_base64;
  }

  async getSignatureByDocument(document: string) {
    let route = `/api/signature-member/`;

    if (document) {
      route += document;
    }

    route += "/get-last-signature";

    const response = await this.instance.get<GetSignatureByDocumentResponse>(route, this.getConfigHeaders());
    return response?.data;
  }

  async storeDocSignature(hash: string, member_id: number, image: string) {
    let route = `/api/signature-process/`;

    if (hash) {
      route += hash;
    }

    route += "/add-signature";

    const payload = {
      member_id: member_id,
      image: image,
    };

    const response = await this.instance.post<SignatureResponse>(route, payload, this.getConfigHeaders());
    return response?.data;
  }
}

export default new SignatureService("", "");
